import { render, staticRenderFns } from "./TakeAttendance.vue?vue&type=template&id=2cecc222&scoped=true"
import script from "./TakeAttendance.vue?vue&type=script&lang=js"
export * from "./TakeAttendance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cecc222",
  null
  
)

export default component.exports